const e = {
  inline: !0,
  group: "inline",
  selectable: !1,
  parseDOM: [{ tag: "br" }],
  toDOM() {
    return ["br"];
  }
};
export {
  e as hardBreakSpec
};
